import React from 'react';
import '../index.css';

export default function SlideShow() {
   return (
      <div id='slideShow'>
         <div className='spaceInvaderHeading'>
            <h1><ion-icon name="planet-sharp"></ion-icon>Space Invaders</h1>
            <ul>
               <p>
                  I built this game as my final project for a course with VetsInTech. 
                  It served as a stepping stone for me to better understand object movement 
                  and collision detection, which helped me develop my next game, "Pac-Man." I've 
                  been making minor improvements whenever I have time and keeping a list of 
                  potential features to make the game more enjoyable.
               </p>
               <p>From this project, I learned:</p>
               <ul>
                  <li>How to use canvas to draw and move objects using setInterval.</li>
                  <li>How to detect object collisions.</li>
                  <li>How to use event listeners to detect keyboard input for movement on the x and y axes within the canvas.</li>
                  <li>How to utilize IDs, classes, and keyframes in CSS and HTML.</li>
               </ul>
            </ul>
            <a className="neonText_green" href="https://miltonmelson.github.io/SpaceInvaders/"><ion-icon name="planet-sharp"></ion-icon>Play Game</a>
            <div className="slider">
               <div className="slides">
                  <div id="slide1-1">
                     <img src={require('../img/a.png')} alt=""></img>
                  </div>
                  <div id="slide1-2">
                     <img src={require("../img/b.png")} alt=""></img>
                  </div>
                  <div id="slide1-3">
                     <img src={require("../img/c.png")} alt=""></img>
                  </div>
               </div>
            </div>
         </div>

         <div className='hackathonHeading'>
            <h1>Roshambo</h1>
            <p>
               Roshambo is a classic game of rock, paper, scissors that utilizes a TCP protocol to 
               facilitate communication between the game server and clients. The game employs multi-threading 
               to support an unlimited number of players and ensures message integrity through the use of a 
               mutex lock in critical areas. In addition, player information and scores are stored in a database via a text file, 
               enabling the creation of a global scoreboard and fostering competition among players.
            </p>
            <a className='neonText_green' href="https://github.com/MiltonMelson/CSS432_23W_Roshambo">Play Game</a>
            <div className="slider">
               <div className="slides">
                  <div id="slide2-1">
                     <img src={require('../img/rps1.png')} alt=""></img>
                  </div>
                  <div id="slide2-2">
                     <img src={require("../img/rps2.png")} alt=""></img>
                  </div>
                  <div id="slide2-3">
                     <img src={require("../img/rps3.png")} alt=""></img>
                  </div>
               </div>
            </div>
         </div>


         <div className='hackathonHeading'>
            <h1>UWB Hackathon 2022 Note Taking App</h1>
            <p>
               Our team built this app using Node.js/Express/MongoDB, Google OAuth20 for authentication, and Handlebars/Materialize for design during the UWB 2022 Hackathon event.
            </p>
            <p>
               The purpose of the app is to make note-taking during class easier and more collaborative. Users can set their notes to public, allowing others who use the app to see and collaborate on notes. This is especially helpful for those who struggle with note-taking or miss class.
            </p>
            <a className='neonText_blue' href="https://tranquil-bastion-78148.herokuapp.com/">Try It Out</a>
            <div className="slider">
               <div className="slides">
                  <div id="slide3-1">
                     <img src={require('../img/note1.png')} alt=""></img>
                  </div>
                  <div id="slide3-2">
                     <img src={require("../img/note2.png")} alt=""></img>
                  </div>
                  <div id="slide3-3">
                     <img src={require("../img/note3.png")} alt=""></img>
                  </div>
                  <div id="slide3-4">
                     <img src={require("../img/note4.png")} alt=""></img>
                  </div>
               </div>
            </div>
         </div>


         <div className="falloutHeading">
            <h1>Fallout Memory Game</h1>
            <p>
               This simple memory game features a Fallout theme and was one of my first projects in VetsInTech. It helped me learn
               how to add functions to objects when clicked or hovered.
            </p>
            <p>
               To win, you need to match all pairs of cards within a set amount of time. Each card has only one matching pair, and
               you can only flip two cards at once to check if they match. When you find a matching pair, those cards stay flipped
               and locked so you can't click on them again.
            </p>
            <a className='neonText_green' href="https://miltonmelson.github.io/FalloutMemoryGame/">Play Game</a>
            <div className="slider">
               <div className="slides">
                  <div id="slide3-1">
                     <img src={require('../img/fallout.png')} alt="Screenshot of the Fallout Memory Game"></img>
                  </div>
               </div>
            </div>
         </div>

         <div class="pixelHeading">
            <h1 id="pixel">Pixel Art Maker</h1>
            <p>
               This is a simple tool that allows you to draw using individual cells as pixels. Before starting to draw, you can pick
               the size of the board.
            </p>
            <a className='neonText_blue' href="https://miltonmelson.github.io/PixelArtMaker/">Try It Out</a>
            <div className="slider">
               <div className="slides">
                  <div id="slide3-1">
                     <img src={require('../img/pixel-art-maker-alt.png')} alt="Screenshot of the Pixel Art Maker tool"></img>
                  </div>
               </div>
            </div>
         </div>

      </div>
   )
}